$(document).ready(function() {
  revealFadeUp();

  $(".dropdown-menu .menu-item-wpml-ls-21-en").click(function(){
    SaveLangue('en');
  });

  $(".dropdown-menu .menu-item-wpml-ls-21-de").click(function(){
    SaveLangue('de');
  });

  $(".dropdown-menu .menu-item-wpml-ls-21-it").click(function(){
    SaveLangue('it');
  });

  $(".dropdown-menu .menu-item-wpml-ls-21-fr").click(function(){
    SaveLangue('fr');
  });
    
    // Écouteur d'événements pour vérifier la visibilité des éléments et déclencher les animations
    $(window).scroll(function () {
        //Counter elements
        $(".counter").each(function () {
            var counterElement = $(this);
            var endNumber = parseInt(counterElement.data("counter-end"));

            if (isElementInViewport(counterElement) && !counterElement.data("animated")) {
                // Démarrez l'animation du compteur et marquez l'élément comme animé
                animateCounter(counterElement, endNumber).then(function () {
                });
                counterElement.data("animated", true);
                
            }
        });
        revealFadeUp();
        //Fade in
    });
    function revealFadeUp() {
        const others = document.querySelectorAll(".reveal");
        const windowHeight = window.innerHeight;
        const elementVisible = 0;

        others.forEach(el => {
            const elementTop = el.getBoundingClientRect().top;

            if (elementTop < windowHeight - elementVisible) {
                el.classList.add("anim-active");
                el.style.animationDelay = "0s";
            } else {
                el.classList.remove("anim-active");
            }
        });
    }
  
    /*----------- Slogan Animation ---------------*/

    const items = $('.slogan-item');


    if (items.length > 0) {
        let currentIndex = 0;
        const intervalTime = 5100;

        function showNextItem() {
            items.eq(currentIndex).removeClass('active');
            currentIndex = (currentIndex + 1) % items.length;
            items.eq(currentIndex).addClass('active');
        }
        items.eq(currentIndex).addClass('active');
        setInterval(showNextItem, intervalTime);
    };

/* SLICK INIT*/

//agence-single

  $('.team-member-container').slick({
    prevArrow: ".team-controls .btn-prev",
    nextArrow: ".team-controls .btn-next",
    dots:true,
    swipe: true,
    swipeToSSlide: true,
    touchMove: true,
    appendDots:".team-dots-container",
    centerMode: true,
    variableWidth: true,
    touchThreshold:300,
  });


  $('.simple-slider .cards').slick({
    infinite: true,
    slidesToScroll: 1,
    prevArrow: ".controls .btn-prev",
    nextArrow: ".controls .btn-next",
    variableWidth: true,
    touchThreshold:300,
    swipe: true,
    swipeToSlide: true,
    touchMove: true,
    responsive: [
      {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
      }
    ]
    });

    $('.simple-slider-history .cards').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: ".controls .btn-prev",
      nextArrow: ".controls .btn-next",
      variableWidth: true,
      touchThreshold:300,
      swipe: true,
      swipeToSlide: true,
      touchMove: true,
      responsive: [
        {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          touchThreshold:300,
          swipe: true,
          swipeToSlide: true,
          touchMove: true
        }
        }
      ]
    });
  
});

// Fonction pour sauvegarder la langue de navigation choisi
function SaveLangue(lang){
  var langdata = localStorage.getItem("flexsis-language");
  if(!langdata){
      window.localStorage.setItem('flexsis-language', lang);
  } else {
      localStorage.removeItem("flexsis-language");
      window.localStorage.setItem('flexsis-language', lang);
  }

}


// Fonction pour vérifier si un élément est visible à l'écran
function isElementInViewport(el) {
    const rect = el[0].getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// Fonction pour animer un compteur à partir de la valeur actuelle jusqu'à la valeur finale.
function animateCounter(counterElement, endNumber) {
    return new Promise(function(resolve) {
      var currentNumber = endNumber-25;

      function updateCounter() {
        if (currentNumber < endNumber) {
          currentNumber++;
          counterElement.text(currentNumber);
        } else {
          clearInterval(interval);
          resolve(); // Résolve la promesse lorsque le compteur atteint la valeur finale.
        }
      }

      var interval = setInterval(updateCounter, 60); // La mise à jour toutes les 60 millisecondes (ajustez selon vos besoins).
    });
}
